import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie names must match backend/deps.py (CSRF_COOKIE, CSRF_HEADER)
const CSRF_COOKIE = 'highlightai_csrf';
const CSRF_HEADER = 'X-CSRF-Token';

const readCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

const api = axios.create({
  baseURL: API,
  withCredentials: true, // send/receive httpOnly auth cookies
});

api.interceptors.request.use((config) => {
  const method = (config.method || 'get').toUpperCase();
  if (method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS') {
    const csrf = readCookie(CSRF_COOKIE);
    if (csrf) {
      config.headers = config.headers || {};
      config.headers[CSRF_HEADER] = csrf;
    }
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const p = window.location.pathname;
      // Public pages: never redirect to /login on a 401 (e.g., /auth/me probe on cold load).
      const PUBLIC_PATHS = ['/', '/login', '/register', '/pricing', '/legal', '/showcase'];
      const isPublic = PUBLIC_PATHS.some((pp) => p === pp || p.startsWith(pp + '/')) || p.startsWith('/share/');
      if (!isPublic) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
